import React from 'react';
import { DentalPractice } from '../../types';
import { Phone, Mail, Users, MapPin } from 'lucide-react';
interface PracticePinProps {
  practice: DentalPractice;
}
export function PracticePin({
  practice
}: PracticePinProps) {
  const getColor = (territory: DentalPractice['territory']) => {
    switch (territory) {
      case 'Nord':
        return 'bg-blue-500 text-white shadow-blue-500/30';
      case 'Mitte':
        return 'bg-teal-500 text-white shadow-teal-500/30';
      case 'Süd':
        return 'bg-amber-500 text-white shadow-amber-500/30';
    }
  };
  return <div className="absolute group z-10" style={{
    left: `${practice.coordinates.x}%`,
    top: `${practice.coordinates.y}%`,
    transform: 'translate(-50%, -100%)'
  }} data-id="element-94">
      {/* Pin Marker */}
      <button className={`
          relative flex items-center justify-center w-8 h-8 rounded-full shadow-lg transform transition-all duration-200 ease-out
          group-hover:scale-110 group-hover:-translate-y-1 group-focus:scale-110 group-focus:-translate-y-1 outline-none
          ${getColor(practice.territory)}
        `} aria-label={`Details zu ${practice.name}`} data-id="element-95">
        <MapPin className="w-4 h-4 fill-current" data-id="element-96" />

        {/* Pulse effect for active feel */}
        <span className="absolute -inset-1 rounded-full opacity-0 group-hover:opacity-20 group-hover:animate-ping bg-current" data-id="element-97"></span>
      </button>

      {/* Tooltip - z-40 to stay below modals (z-50) */}
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-3 w-64 opacity-0 invisible group-hover:opacity-100 group-hover:visible group-focus-within:opacity-100 group-focus-within:visible transition-all duration-200 transform origin-bottom scale-95 group-hover:scale-100 z-40 pointer-events-none" data-id="element-98">
        <div className="bg-white rounded-lg shadow-xl border border-slate-100 p-4 text-left" data-id="element-99">
          <h4 className="font-bold text-slate-900 mb-1" data-id="element-100">{practice.name}</h4>
          <p className="text-xs text-slate-500 mb-3 leading-relaxed" data-id="element-101">
            {practice.address}
            <br data-id="element-102" />
            {practice.city}
          </p>

          <div className="space-y-1.5" data-id="element-103">
            <div className="flex items-center gap-2 text-xs text-slate-600" data-id="element-104">
              <Phone className="h-3 w-3 text-slate-400" data-id="element-105" />
              <span data-id="element-106">{practice.phone}</span>
            </div>
            <div className="flex items-center gap-2 text-xs text-slate-600" data-id="element-107">
              <Mail className="h-3 w-3 text-slate-400" data-id="element-108" />
              <span className="truncate" data-id="element-109">{practice.email}</span>
            </div>
            <div className="flex items-center gap-2 text-xs text-slate-600" data-id="element-110">
              <Users className="h-3 w-3 text-slate-400" data-id="element-111" />
              <span data-id="element-112">{practice.employees} Mitarbeiter</span>
            </div>
          </div>

          {/* Tooltip Arrow */}
          <div className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-3 h-3 bg-white border-b border-r border-slate-100 transform rotate-45" data-id="element-113"></div>
        </div>
      </div>
    </div>;
}